import { __decorate, __metadata, __param } from 'tslib';
import { ɵɵdefineInjectable, ɵɵinject, Injectable, NgModule, Optional, SkipSelf } from '@angular/core';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { PasswordValidator, MatchValidator, ErrorMessageService } from '@wlp/ui-bs-util';
import { SpeViewNAccountProxy, SpeViewNMenuProxy, SpeExtOauthProxy, SpeExtUsersProxy, UiPxMyDataModule } from '@wlp/ui-px-my-data';
import { UiBsTranslateService, UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { Storage } from '@ionic/storage';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';

let UiBsMyDataService = class UiBsMyDataService {
    constructor(formBuilder, errorMessageService, speViewNAccountProxy) {
        this.formBuilder = formBuilder;
        this.errorMessageService = errorMessageService;
        this.speViewNAccountProxy = speViewNAccountProxy;
        this.errorMessages = {
            cnpj: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.CNPJ.MESSAGE.REQUIRED' },
                {
                    type: 'cnpjNotValid',
                    message: 'ONBORDING.COMPANY_DATA.FORM.CNPJ.MESSAGE.CNPJ_NOT_VALID'
                }
            ],
            companyName: [
                { type: 'required', message: 'ONBORDING.COMPANY_DATA.FORM.COMPANY_NAME.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.COMPANY_DATA.FORM.COMPANY_NAME.MESSAGE.MIN_LENGTH',
                    param: { minLength: 6 }
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.COMPANY_DATA.FORM.COMPANY_NAME.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 100 }
                },
            ],
            name: [
                { type: 'minlength', message: 'ONBORDING.COMERCIAL_AGENT.FORM.NAME_AGENT.MESSAGE.MIN_LENGTH' },
                { type: 'maxlength', message: 'ONBORDING.COMERCIAL_AGENT.FORM.NAME_AGENT.MESSAGE.MAX_LENGTH' },
            ],
            cpf: [
                { type: 'cpfNotValid', message: 'ONBORDING.COMERCIAL_AGENT.FORM.CPF_AGENT.MESSAGE.CPF_NOT_VALID' }
            ],
            email: [
                { type: 'required', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.REQUIRED' },
                { type: 'minlength', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.MIN_LENGTH', param: { minLength: 6 } },
                { type: 'maxlength', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.MAX_LENGTH', param: { maxLength: 60 } },
                { type: 'pattern', message: 'ONBORDING.OPEN_ACCOUNT_MASTER.FORM.E_MAIL.MESSAGE.PATTERN' }
            ],
            password: [
                // {
                // type: 'minChar',
                // message: 'ONBORDING.CREATE_PASSWORD.FORM.PASSWORD.MESSAGE.MIN_CHAR',
                // param: {
                // minChar: 1
                // }
                // },
                {
                    type: 'minSpecialChar',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.PASSWORD.MESSAGE.MIN_SPECIAL_CHAR',
                    param: {
                        minSpecialChar: 1
                    }
                },
                {
                    type: 'minNumberChar',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.PASSWORD.MESSAGE.MIN_NUMBER_CHAR',
                    param: {
                        minNumberChar: 1
                    }
                },
                {
                    type: 'minUpperChar',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.PASSWORD.MESSAGE.MIN_UPPER_CHAR',
                    param: {
                        minUpperChar: 1
                    }
                },
                {
                    type: 'minLowerChar',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.PASSWORD.MESSAGE.MIN_LOWER_CHAR',
                    param: {
                        minLowerChar: 1
                    }
                },
                {
                    type: 'hasEmptySpace',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.PASSWORD.MESSAGE.HAS_EMPTY_SPACE',
                }
            ],
            confirmPassword: [
                {
                    type: 'mustMatch',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.CONFIRM_PASSWORD.MESSAGE.MUST_MATCH'
                }
            ],
            certifiedType: [
                { type: 'required', message: 'ONBORDING.PROFESSIONAL_TYPE.FORM.CERTIFIED_TYPE.MESSAGE.REQUIRED' },
            ],
            certifiedNumber: [
                { type: 'required', message: 'ONBORDING.PROFESSIONAL_TYPE.FORM.CERTIFIED_NUMBER.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'ONBORDING.PROFESSIONAL_TYPE.FORM.CERTIFIED_NUMBER.MESSAGE.MIN_LENGTH',
                    param: { minLength: 4 }
                },
                {
                    type: 'maxlength',
                    message: 'ONBORDING.PROFESSIONAL_TYPE.FORM.CERTIFIED_NUMBER.MESSAGE.MAX_LENGTH',
                    param: { maxLength: 20 }
                },
            ]
        };
    }
    getFormMyData() {
        this.formMyData = this.formBuilder.group({
            cnpj: new FormControl('', Validators.compose([])),
            companyName: new FormControl('', Validators.compose([])),
            name: new FormControl('', Validators.compose([])),
            cpf: new FormControl('', Validators.compose([])),
            email: new FormControl('', Validators.compose([])),
            certifiedType: new FormControl('', Validators.compose([])),
            certifiedNumber: new FormControl('', Validators.compose([])),
            currentPassword: new FormControl('', Validators.compose([
                Validators.required,
            ])),
            password: new FormControl('', Validators.compose([
                Validators.required,
                PasswordValidator.minChar,
                PasswordValidator.minUpperChar,
                PasswordValidator.minLowerChar,
                PasswordValidator.minNumberChar,
                PasswordValidator.minSpecialChar,
                PasswordValidator.hasEmptySpace
            ])),
            confirmPassword: new FormControl('')
        }, {
            validator: MatchValidator.mustMatch('password', 'confirmPassword')
        });
        return this.formMyData;
    }
    getFormMessageError() {
        return this.errorMessages;
    }
    prepareUserAccount(uuid) {
        return this.speViewNAccountProxy.getMyData(uuid);
    }
    getUserAccountReduced(uuidAccont) {
        return this.speViewNAccountProxy.getMyDataReduced(uuidAccont);
    }
    getAccountPaymentPerson(uuid) {
        return this.speViewNAccountProxy.getAccountPaymentPerson(uuid);
    }
    getAccountPayment(uuid) {
        return this.speViewNAccountProxy.getAccountPayment(uuid);
    }
    getWhiteLabelData(uuidWhiteLabel) {
        return this.speViewNAccountProxy.getWhiteLabelData(uuidWhiteLabel);
    }
    getPersonalData(uuidWhiteLabel) {
        return this.speViewNAccountProxy.personalData(uuidWhiteLabel);
    }
};
UiBsMyDataService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UiBsMyDataService_Factory() { return new UiBsMyDataService(ɵɵinject(FormBuilder), ɵɵinject(ErrorMessageService), ɵɵinject(SpeViewNAccountProxy)); }, token: UiBsMyDataService, providedIn: "root" });
UiBsMyDataService = __decorate([
    Injectable({
        providedIn: 'root'
    }),
    __metadata("design:paramtypes", [FormBuilder,
        ErrorMessageService,
        SpeViewNAccountProxy])
], UiBsMyDataService);

let MenuService = class MenuService {
    constructor(speViewNMenuProxy, translate) {
        this.speViewNMenuProxy = speViewNMenuProxy;
        this.translate = translate;
    }
    getMenu(uuidWhiteLabel, uuidAccountPayment, type) {
        return this.speViewNMenuProxy.getMenu(uuidWhiteLabel, uuidAccountPayment, type);
    }
    getMenuFilter(uuidWhiteLabel, uuidAccountPayment, type) {
        return this.speViewNMenuProxy.getMenuFilter(uuidWhiteLabel, uuidAccountPayment, type);
    }
};
MenuService.ngInjectableDef = ɵɵdefineInjectable({ factory: function MenuService_Factory() { return new MenuService(ɵɵinject(SpeViewNMenuProxy), ɵɵinject(UiBsTranslateService)); }, token: MenuService, providedIn: "root" });
MenuService = __decorate([
    Injectable({
        providedIn: 'root',
    }),
    __metadata("design:paramtypes", [SpeViewNMenuProxy,
        UiBsTranslateService])
], MenuService);

let ChangePasswordService = class ChangePasswordService {
    constructor(formBuilder, storage, errorMessageService, speExtOauthProxy, speExtUsersProxy) {
        this.formBuilder = formBuilder;
        this.storage = storage;
        this.errorMessageService = errorMessageService;
        this.speExtOauthProxy = speExtOauthProxy;
        this.speExtUsersProxy = speExtUsersProxy;
        this.errorFormMessages = {
            password: [
                {
                    type: 'minSpecialChar',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.PASSWORD.MESSAGE.MIN_SPECIAL_CHAR',
                    param: {
                        minSpecialChar: 1
                    }
                },
                {
                    type: 'minNumberChar',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.PASSWORD.MESSAGE.MIN_NUMBER_CHAR',
                    param: {
                        minNumberChar: 1
                    }
                },
                {
                    type: 'minUpperChar',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.PASSWORD.MESSAGE.MIN_UPPER_CHAR',
                    param: {
                        minUpperChar: 1
                    }
                },
                {
                    type: 'minLowerChar',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.PASSWORD.MESSAGE.MIN_LOWER_CHAR',
                    param: {
                        minLowerChar: 1
                    }
                },
                {
                    type: 'hasEmptySpace',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.PASSWORD.MESSAGE.HAS_EMPTY_SPACE',
                }
            ],
            confirmPassword: [
                {
                    type: 'mustMatch',
                    message: 'ONBORDING.CREATE_PASSWORD.FORM.CONFIRM_PASSWORD.MESSAGE.MUST_MATCH'
                }
            ]
        };
    }
    getForm() {
        this.formPassword = this.formBuilder.group({
            password: new FormControl('', Validators.compose([
                Validators.required,
                PasswordValidator.minChar,
                PasswordValidator.minUpperChar,
                PasswordValidator.minLowerChar,
                PasswordValidator.minNumberChar,
                PasswordValidator.minSpecialChar,
                PasswordValidator.hasEmptySpace
            ])),
            confirmPassword: new FormControl('', Validators.compose([
                Validators.required
            ])),
        }, {
            validator: MatchValidator.mustMatch('password', 'confirmPassword')
        });
        return this.formPassword;
    }
    getErrorFormMessage() {
        return this.errorFormMessages;
    }
    getErrorPassword(error) {
        this.errorMessageService.getError(error);
    }
    validationPassword(body, accountPayment) {
        return this.speExtOauthProxy.consultValidationPassword(body, accountPayment);
    }
    updateValidationPassword(body, uuidAccount) {
        return this.speExtUsersProxy.updateValidationPassword(body, uuidAccount);
    }
    validationPasswordEmail(body, uuidAccount) {
        return this.speExtUsersProxy.validationPasswordEmail(body, uuidAccount);
    }
};
ChangePasswordService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [FormBuilder,
        Storage,
        ErrorMessageService,
        SpeExtOauthProxy,
        SpeExtUsersProxy])
], ChangePasswordService);

class UserAccountInfoResponse {
}

class WhiteLabelDataResponse {
}

var UiBsMyDataModule_1;
let UiBsMyDataModule = UiBsMyDataModule_1 = class UiBsMyDataModule {
    constructor(parentModule) {
        //.....
    }
    static forRoot(config) {
        return {
            ngModule: UiBsMyDataModule_1,
            providers: [{ provide: APP_PARAMETER, useValue: config }],
        };
    }
};
UiBsMyDataModule = UiBsMyDataModule_1 = __decorate([
    NgModule({
        declarations: [],
        imports: [UiPxMyDataModule, UiBsTranslateModule],
        providers: [UiBsMyDataService, MenuService, ChangePasswordService],
    }),
    __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [UiBsMyDataModule])
], UiBsMyDataModule);

export { ChangePasswordService, MenuService, UiBsMyDataModule, UiBsMyDataService, UserAccountInfoResponse, WhiteLabelDataResponse };
//# sourceMappingURL=wlp-ui-bs-my-data.js.map
